import React, {useContext} from 'react'
import {Link, useHistory} from "react-router-dom"
import { makeStyles } from '@material-ui/core/styles';
import MuiToolbar from "@material-ui/core/Toolbar";
import Button from "@material-ui/core/Button"
import IconButton from "@material-ui/core/IconButton";
import SvgIcon from "@material-ui/core/SvgIcon";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import { AuthContext } from "../../components";
import { HeadsetMic } from "@material-ui/icons"
import { ArrowBack } from "@material-ui/icons";
import {ReactComponent as PhoneThruLogo} from "../../images/phonethru-logo.svg";


// Create the logout icon which is inexplicably missing from the Material UI icon library
const LogoutIcon = (props) => (
    <SvgIcon {...props}>
        <path d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z" />
    </SvgIcon>
)

const useStyles = makeStyles((theme) => ({
    toolbar: {
        background: 'linear-gradient(45deg, ' + theme.palette.primary.main + ' 30%, ' + theme.palette.primary.dark + ' 90%)',
        //background: 'linear-gradient(45deg, ' + theme.palette.secondary.main + ' 30%, ' + theme.palette.secondary.dark + ' 90%)',
        //background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
        //backgroundColor: 'white',
        paddingRight: 6,
        paddingLeft: 10,
    },
    logo: {
        paddingLeft: 6,
        width: 120,
        height: 24,
    },
    button: {
        textTransform: 'none',
        //color: '#0000008a',
        color: 'white',
        '&:focus': {
          outline: 'none',
        },
    },
    backButton: {
        textTransform: 'none',
        paddingLeft: 0,
        color: 'white',
    },
}));



const HeaderToolbar = ({location}) => {
    const classes = useStyles();
    const auth = useContext(AuthContext)
    const history = useHistory();

    // Set the returnTo location
    const state = initialState(location);

    const handleLogoutClick = (event) => {
        event.preventDefault();
        auth.logout(history);
    }


    return (
        // Header
        <MuiToolbar className={classes.toolbar}>
            <Grid container direction="row" justify="space-between" alignItems="center">
                <Grid item>
                    { state.location === '/home' &&
                    <Grid container alignItems="center">
                        <PhoneThruLogo className={classes.logo} fill="white"/>
                    </Grid>
                    }
                    { state.location !== '/home' &&
                    <Button component={Link} to={state.returnUrl} className={classes.backButton}>
                        <ArrowBack/>
                        Back to {state.label}
                    </Button>
                    }
                </Grid>
                <Hidden xsDown>
                    <Grid item>
                        <Button className={classes.button} component={Link} to="/support" aria-label="support">
                            <HeadsetMic/> Support
                        </Button>
                        <Button className={classes.button} aria-label="logout" onClick={(e) => handleLogoutClick(e)}>
                            <LogoutIcon/> Log Out
                        </Button>
                    </Grid>
                </Hidden>
                <Hidden smUp>
                    <Grid item>
                        <Grid container spacing={1}>
                            <Grid item>
                                <IconButton className={classes.button} component={Link} to="/support" aria-label="support">
                                    <HeadsetMic/>
                                </IconButton>
                            </Grid>
                            <Grid item>
                                <IconButton className={classes.button} aria-label="logout" onClick={handleLogoutClick}>
                                    <LogoutIcon/>
                                </IconButton>
                            </Grid>

                        </Grid>

                    </Grid>
                </Hidden>
            </Grid>

        </MuiToolbar>

    )

}


const initialState = (location) => {

    if (location.startsWith('/support/')) {
        return {returnUrl: '/support', label: 'Support', location}
    } else if (location.startsWith('/account/')) {
        return {returnUrl: '/account', label: 'Account', location}
    } else if (location === '/home') {
        return {returnUrl: '', label: '', location}
    } else {
        return {returnUrl: '/home', label: 'Home', location}
    }

}

export default HeaderToolbar;
